/* Title
------------------------*/
    export let title1 = document.querySelector('#home-title1');
    export let title2 = document.querySelector('#home-title2');

/* Desktop
------------------------*/
    export let men = document.querySelector('#men');
    export let desktop = document.querySelector('#deck');
    export let screens = document.querySelectorAll('#deck #screens g');
    export let screenOneRect = document.querySelectorAll('screen-1 #screen-1-rect path');
    export let screenTwoRect = document.querySelectorAll('#screen-2 #screen-2-rect path');
    export let screenThreeRect = document.querySelector('#screen-3 #screen-3-rect');

/* Cogs
------------------------*/
    export let cogsGroup = document.querySelector('#cogs');
    export let cogsSmallOne = document.querySelector('#cog-small-1');
    export let cogsSmallTwo = document.querySelector('#cog-small-2');
    export let cogsLarge = document.querySelector('#cog-large');

/* Line cogs
------------------------*/
    export let lineCogsGroup = document.querySelector('#line-cogs');
    export let lineCogsLeft = document.querySelector('#line-left');
    export let lineCogsBottom = document.querySelector('#line-bottom');
    export let lineCogsTop = document.querySelector('#line-top');
    export let lineCogsRight = document.querySelector('#line-right');
    export let roundCogs = document.querySelector('#round-cogs');

/* Box
------------------------*/
    export let box = document.querySelector('#box');
    export let wifiRed = document.querySelectorAll('#wifi-red path');


/* Chart
------------------------*/
    export let ChartGroup = document.querySelectorAll('#charts g');
    export let ChartOne = document.querySelector('#chart-1');
    export let ChartTwo = document.querySelector('#chart-2');
    export let ChartThree = document.querySelector('#chart-3');
    export let ChartFour = document.querySelector('#chart-4');

/* Born
------------------------*/
    export let bornLeft = document.querySelector('#borne-left');
    export let bornLeftText = document.querySelectorAll('#bl-text g polygon');
    export let bornLeftSquare = document.querySelectorAll('#bl-square path');

    export let bornRight = document.querySelector('#borne-right');
    export let bornRightSquare = document.querySelectorAll('#borne-right #br-square path');
    export let lineBorn = document.querySelector('#line-born');

/* Woman
------------------------*/
    export let woman = document.querySelector('#woman');

/* payment
------------------------*/
    export let bornPayment = document.querySelector('#born-payment');

/* Phone
------------------------*/
    export let phone = document.querySelector('#phone');
    export let phoneRectBottom = document.querySelectorAll('#phone #phone-rect-bottom polygon');
    export let phoneRectTopPoly = document.querySelectorAll('#phone #phone-rect-top polygon');
    export let phoneRectTopPath = document.querySelectorAll('#phone #phone-rect-top path');
    export let wifiBlue = document.querySelectorAll('#wifi-blue path');
    export let linePayment = document.querySelector('#line-payment');
    export let lineUnderPhoneRight = document.querySelector('#line-under-phone-right');
    export let lineUnderPhoneBottom = document.querySelector('#line-under-phone-bottom');
    export let lineUnderPhoneLeft = document.querySelector('#line-under-phone-left');
    export let lineUnderPhoneTop = document.querySelector('#line-under-phone-top');
    export let lineRoundPhone = document.querySelector('#round-phone');
